import { c as _c } from "react-compiler-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import { FEATURES } from '../constants/features';
import { TABS } from '../constants/tabs';
import Tab from './sidebar/Tab';
import { MIN_SIDEBAR_WIDTH } from '../constants/sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
// For tab content that needs to be rendered outside of the iFrame
export default function ParentRenderedContent(t0) {
  "use memo";

  const $ = _c(9);
  const {
    tab,
    show,
    enabledFeatures,
    ApprovalsContent,
    ReviewContent
  } = t0;
  let t1;
  bb0: {
    if (!show || !(enabledFeatures !== null && enabledFeatures !== void 0 && enabledFeatures.length)) {
      t1 = null;
      break bb0;
    }
    if (tab === TABS.APPROVALS && enabledFeatures.includes(FEATURES.APPROVALS) && ApprovalsContent) {
      t1 = ApprovalsContent;
      break bb0;
    }
    if (tab === TABS.REVIEW && enabledFeatures.includes(FEATURES.REVIEW) && ReviewContent) {
      t1 = ReviewContent;
      break bb0;
    }
    t1 = null;
  }
  const Content = t1;
  if (!Content) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "100%",
      minWidth: MIN_SIDEBAR_WIDTH
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = `collaborationSidebar.tabs.${tab}`;
  let t4;
  if ($[1] !== t3) {
    t4 = /*#__PURE__*/_jsx(FormattedMessage, {
      message: t3
    });
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== Content) {
    t5 = /*#__PURE__*/_jsx(Content, {});
    $[3] = Content;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5 || $[7] !== tab) {
    t6 = /*#__PURE__*/_jsx("div", {
      style: t2,
      children: /*#__PURE__*/_jsx(Tab, {
        heading: t4,
        tab: tab,
        children: t5
      })
    });
    $[5] = t4;
    $[6] = t5;
    $[7] = tab;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}